import React from 'react';
import DocumentCard from './DocumentCard';
import DocumentRow from './DocumentRow';

const DocumentsList = ({
  documents,
  loading,
  source,
  deletingDocumentId,
  onDelete,
  compact,
  t
}) => {
  if (loading) {
    return (
      <p className="tw-text-xs tw-text-gray-500">
        {t('customerDocuments.loading', { defaultValue: 'Cargando documentos...' })}
      </p>
    );
  }

  if (!documents.length) {
    return (
      <p className="tw-text-xs tw-text-gray-500">
        {t('customerDocuments.empty', { defaultValue: 'No hay documentos cargados.' })}
      </p>
    );
  }

  if (source === 'crm') {
    return (
      <div className="tw-grid tw-grid-cols-1 tw-gap-2 sm:tw-grid-cols-2 md:tw-grid-cols-3 xl:tw-grid-cols-4 2xl:tw-grid-cols-5">
        {documents.map((document) => (
          <DocumentCard
            key={document.id}
            document={document}
            onDelete={onDelete}
            deleting={deletingDocumentId === document.id}
            compact={compact}
            t={t}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="tw-space-y-2">
      {documents.map((document) => (
        <DocumentRow
          key={document.id}
          document={document}
          onDelete={onDelete}
          deleting={deletingDocumentId === document.id}
          compact={compact}
          t={t}
        />
      ))}
    </div>
  );
};

export default DocumentsList;
